module.exports = __webpack_public_path__ + "static/media/Service Dogs.b1015f30.svg";